import React, { Component } from 'react';
import { observer } from 'mobx-react';

import AppUser from 'js/stores/AppUser';
import LoginSignupDialogState from 'js/stores/LoginSignupDialogState';

import FacebookConnectButton from './FacebookConnectButton';
import GoogleConnectButton from './GoogleConnectButton';
import Login from './Login';
import Signup from './Signup';
import WelcomeBackMessage from './WelcomeBackMessage';
import Title from './Title';
import SubTitle from './SubTitle';
import Container from './Container';
import SwitchDialog from './SwitchDialog';
import TermsOfService from './TermsOfService';
import SocialNetworkConnectError from './SocialNetworkConnectError';
import Or from './Or';
import Modal from "js/components/core/Modal";
import SafariWarning from "./SafariWarning";
import { GoogleLogin } from 'react-google-login';
import GoogleAuth from "js/services/auth-driver/GoogleAuth";
import { makeRequest } from "js/services/Network";
import AnonymousId from "js/services/AnonymousId";
import analytics from "js/services/Analytics";
import AppState from "js/stores/AppState";

const noop = () => null;

@observer
export default class LoginSignupDialog extends Component {
  loginSignupDialog = LoginSignupDialogState.create();
  wasLoggedIn = false;

  static defaultProps = {
    facebook: true,
    google: true,
    singleUseToken: null,
    mseller: false,
  };

  componentDidMount() {
    this.props.showForm && this.loginSignupDialog.setShowForm(this.props.showForm);
    this.wasLoggedIn = AppUser.isLoggedIn;
    this.wasLoggedIn && this.runAfterTask();
  }

  componentWillUnmount() {
    AppState.setDialogProps({});
  }

  beforeConnect = () => this.loginSignupDialog.clearError() && (this.props.before || noop)();
  runAfterTask = () => (this.props.afterLogin || this.props.after || noop)();

  onGoogleConnect = response => {
    let tracking;
    if (!response) {
      console.log("no response");
      return;
      // this.beforeConnect();
    }

    analytics.identify(response);

    const prefix = analytics.loginPrefix();

    if (response.is_new_user) {
      tracking = analytics
        .track(`${prefix}account_created_google`, {
          'Email': response.email,
          'Signup Method': 'Google',
          'Name': "",
          'Address': "",
          'Position': AppState.currentPage.indexOf('LandingPage') !== -1 ? 'landing' : 'create-link',
          'Event Initiated by': AppState.currentPage === 'CreatePaymentLinkPage' || AppState.currentPage === 'SellerLandingPage'
            ? 'seller' : 'buyer'
        });
    } else {
      tracking = analytics
        .track(`${prefix}logged_in_google`, {
          'Email': response.email,
          'Signup Method': 'Google',
          'Name': "",
          'Address': "",
          'Position': AppState.currentPage.indexOf('LandingPage') !== -1 ? 'landing' : window.location.href,
          'Event Initiated by': AppState.currentPage === 'CreatePaymentLinkPage' || AppState.currentPage === 'SellerLandingPage'
            ? 'seller' : 'buyer'
        });
    }
    analytics.track('CTA_Engaged_User', {
      'Email': response.email,
      'Signup/Login Method': 'Google',
      'Date': new Date().toString(),
      'Position': AppState.currentPage.indexOf('LandingPage') !== -1 ? 'landing' : window.location.href,
      'Event Initiated by': AppState.currentPage === 'CreatePaymentLinkPage' || AppState.currentPage === 'SellerLandingPage'
        ? 'seller' : 'buyer'
    })
    return tracking.then(this.runAfterTask);
  };

  googleOnSuccess = (response) => {
    try {
      GoogleAuth
        .loginDirect(response.accessToken, {
          single_use_token: this.props.singleUseToken,
          mseller: this.props.mseller
        })
        .then(response => {
          AppUser.handleResponse('google', response);
          return response;
        })
        .then(this.onGoogleConnect)
    } catch (error) {
      throw error;
    }
  }

  render() {
    const { showForm, setError, error, toggleDisplay, closeSafariWarning } = this.loginSignupDialog;
    const before = this.props.before || noop;
    const page = this.props.page;

    const {
      after,
      predicate,
      signupTitle,
      signupText,
      loginTitle,
      loginText,
      loginButtonLabel,
      signupButtonLabel,
      facebookButtonLabel,
      googleButtonLabel,
      termsOfService,
      padded,
      facebook,
      google,
      marketing,
      singleUseToken,
      mseller,
      showForgotPassword,
      showButtonsOnly,
    } = this.props;

    let title = null;
    let subTitle = null;
    if (loginTitle && showForm === 'login') {
      title = <Title>{loginTitle}</Title>;
      if (loginText) {
        subTitle = <SubTitle>{loginText}</SubTitle>;
      }
    } else if (signupTitle && showForm === 'signup') {
      title = <Title>{signupTitle}</Title>;
      if (signupText) {
        subTitle = <SubTitle>{signupText}</SubTitle>;
      }
    }

    return this.wasLoggedIn ? (
      <WelcomeBackMessage />
    ) : (
      <Container padded={padded}>
        {title}
        {subTitle}

        {((facebook || google) && showButtonsOnly === undefined) &&  (<SwitchDialog
          onSwitch={toggleDisplay}
          text={showForm === 'login' ? 'New to PayOnDelivery?' : 'Already have an account?'}
          link={showForm === 'login' ? 'Sign Up' : 'Log In'}
        />)}

        {(facebook) && (
          <FacebookConnectButton
            onConnect={this.runAfterTask}
            onError={setError}
            beforeConnect={this.beforeConnect}
            predicate={predicate}
            page={page}
            mseller={mseller}
            addParams={{
              single_use_token: singleUseToken,
              mseller: mseller,
            }}
          >
            {facebookButtonLabel}
          </FacebookConnectButton>
        )}

        {(google) && (
          <GoogleLogin
            clientId={window.app.googleSignInClientId}
            render={renderProps => (
              <GoogleConnectButton
                id="gSignInWrapper"
                callParentClick={renderProps.onClick}
                page={page}
                mseller={mseller}
              >
                {googleButtonLabel}
              </GoogleConnectButton>
            )}
            onSuccess={this.googleOnSuccess}
            onFailure={(error) => console.log('error', error)}
            cookiePolicy={'single_host_origin'}
          />
        )}

        <SocialNetworkConnectError error={error} />

        {((google || facebook) && showButtonsOnly === undefined) && (<Or />)}


        {showForm === 'login' && showButtonsOnly === undefined ?  (
          <Login
            predicate={predicate}
            before={() => before('Login And Pay')}
            after={this.runAfterTask}
            submitLabel={loginButtonLabel}
            page={page}
            token={singleUseToken}
            mseller={mseller}
            showForgotPassword={showForgotPassword === undefined ? true : showForgotPassword}
          />
        ) : showButtonsOnly === undefined ? (
          <Signup
            predicate={predicate}
            before={() => before('Signup And Pay')}
            after={after}
            submitLabel={signupButtonLabel}
            referral={this.props.referral}
            page={page}
            marketing={marketing}
          />
        ) : ''}

        {termsOfService && <TermsOfService />}



        <Modal showModal={this.loginSignupDialog.safariWarning} onCancel={closeSafariWarning} withCloseButton>
          <SafariWarning state={this.loginSignupDialog} />
        </Modal>
      </Container>
    );
  }
}
